import { z } from 'zod';

export const countdownConfigSchema = z.object({
  countdownTo: z.union([z.literal('couponExpiry'), z.literal('promoEndDate')]),
  buttonLabelOverride: z.string().nullable(),
  blurb: z.string().nullable(),
  showTimerFromHours: z.number().nullable(),
  displayMode: z.enum(['dhms', 'hms']).nullable(),
});

export type CountdownConfig = z.infer<typeof countdownConfigSchema>;
